import React from "react";
import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Accordion from "../components/Accodion";

function Contact2() {
  const [accordions, setAccordion] = useState([
    {
      key: 1,
      title: "홈페이지 접속시 접속 오류가 발생합니다.",
      data: `홈페이지 접속시 발생하는 접속 오류에 대한 답변입니다.`,
      isOpen: false,
    },
    {
      key: 2,
      title: "궁금한 점은 어디로 문의하면 되나요?",
      data: `궁금한 점은 코끼리협동조합 홈페이지의 문의 탭의 상담 신청을 통해 문의해주세요.`,
      isOpen: false,
    },
    {
      key: 3,
      title: "메이커스페이스 운영 시간은 어떻게 되나요?",
      data: `평일 오전 9시부터 오후 6시까지 운영됩니다.`,
      isOpen: false,
    },
    // {
    //   key: 4,
    //   title: "홈페이지 접속시 접속 오류가 발생합니다.",
    //   data: `GeeksforGeeks is a one stop solution  
    //               for all computer science students.`,
    //   isOpen: false,
    // },
    // {
    //   key: 5,
    //   title: "궁금한 점은 어디로 문의하면 되나요?",
    //   data: `GeeksforGeeks offers Free Tutorials,  
    //               Millions of Articles, Live, Online and  
    //               Classroom Courses,Frequent Coding Competitions,  
    //               Webinars by Industry Experts, Internship  
    //               opportunities and Job Opportunities.`,
    //   isOpen: false,
    // },
    // {
    //   key: 6,
    //   title: "메이커스페이스 운영 시간은 어떻게 되나요?",
    //   data: `GeeksforGeeks is the best Computer Science portal  
    //               for geeks. It contains well written, well thought  
    //               and well explained computer science and programming  
    //               articles.`,
    //   isOpen: false,
    // },
  ]);

  const toggleAccordion = (accordionkey) => {
    const updatedAccordions = accordions.map((accord) => {
      if (accord.key === accordionkey) {
        return { ...accord, isOpen: !accord.isOpen };
      } else {
        return { ...accord, isOpen: false };
      }
    });

    setAccordion(updatedAccordions);
  };

  return (
    <div className="container mx-auto">
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center w-full px-24">
          <div className="w-full border-t-2 border-gray-300">
            {accordions.map((accordion) => (
              <Accordion
                key={accordion.key}
                title={accordion.title}
                data={accordion.data}
                isOpen={accordion.isOpen}
                toggleAccordion={() => toggleAccordion(accordion.key)}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Contact2;
